import { useContext, useEffect, useState } from 'react'

import { HubVisitContext } from '@/hooks/client/hub-visit-context'

import { startGuideEligibility } from './guide-eligibility-check'

export const useGuideEligibility = () => {
  const visit = useContext(HubVisitContext)
  const [acceptedVisit, setAcceptedVisit] = useState<typeof visit>()

  useEffect(() => startGuideEligibility(visit, () => setAcceptedVisit(visit)), [visit])

  // Route identity is available during prerender; the analytics ID is browser-only.
  return acceptedVisit === visit
}
